import MuiChip from '@mui/material/Chip'; // Note that this implicitly renames the import from Chip to MuiChip to avoid naming conflicts below. The MUI component is NOT named MuiChip.
import type { JSX } from 'react';

interface ChipProps {
    children: string;
}

export const Chip = (props: ChipProps): JSX.Element => {
    const blueColor = getComputedStyle(document.documentElement).getPropertyValue('--hps-dark-blue');
    const font = getComputedStyle(document.documentElement).getPropertyValue('--hps-primary-font');

    return <MuiChip size="small" label={props.children} sx={{ backgroundColor: blueColor, color: '#FFFFFF', fontFamily: font, fontWeight: 'bold' }} />;
};
